'use client';

import { BookDemoButton } from '@/components/ui';
import { Button } from '@/components/ui/Button';
import IndustryHero from '@/components/industry/IndustryHero';
import TelecomCommandCentre from './TelecomCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

export default function TelecomHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('industries_telecom.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('industries_telecom.telecom'),
      }}
      title={
        <>
          {t('industries_telecom.hero_title_line1')}{' '}
          <span className="serif-accent italic">{t('industries_telecom.hero_title_accent')}</span>
        </>
      }
      lead={t('industries_telecom.hero_subhead')}
      actions={
        <>
          <BookDemoButton label={t('industries_telecom.hero_cta_primary')} />
          <Button href="#capabilities" variant="ghost" size="lg">
            {t('industries_telecom.hero_cta_secondary')}
          </Button>
        </>
      }
      visual={<TelecomCommandCentre />}
    />
  );
}
